import Menu from '@mui/material/Menu';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import MenuItemContainer, { MenuOptions } from './MenuItemContainer';

export interface MenuContainerProps {
  open: boolean;
  isMobile: boolean;
  menuOptions: MenuOptions[];
  anchorEl: HTMLElement | null;
  activeIndex: number;
  handleMenuClose: () => void;
}

const MenuContainer = ({ open, isMobile, menuOptions, anchorEl, activeIndex, handleMenuClose }: MenuContainerProps) => {
  const theme = useTheme();

  return (
    <Menu
      MenuListProps={{
        sx: !isMobile
          ? {
              p: 0,
              width: '100%',
              background: theme.palette.secondary.light
            }
          : {
              padding: '40px 32px',
              background: theme.palette.secondary.light
            }
      }}
      sx={{
        marginTop: '16px',
        display: isMobile ? 'flex' : 'none'
      }}
      open={open}
      anchorEl={anchorEl}
      onClose={handleMenuClose}
    >
      <MenuItemContainer menuOptions={menuOptions} isMobile={isMobile} activeIndex={activeIndex} />
    </Menu>
  );
};

export default MenuContainer;
